import { useEffect } from 'react';

import { Comment } from '@Comments/components/Comment/Comment';
import { EditorialMessage } from '@Comments/components/Comment/EditorialMessage';
import { useAppContext } from '@Comments/context/AppContext';
import ShowMoreBar from '@fec/frontend/modules/groups-and-lists/show-more-bar/show-more-bar';
import { useLoaderActions } from '@Comments/services/useLoaderActions';
import { Spinner } from '@Comments/components/Spinner/Spinner';
import { Error } from '@Comments/components/Error/Error';

import './Comments.scss';

export const Comments = () => {
  const { comments, hasMoreComments, appState, sortOrder, limit, thread } =
    useAppContext();
  const loaderActions = useLoaderActions();

  const handleShowMore = () => {
    loaderActions.loadComments(
      Math.min(1000, limit * 3),
      'comments-loading-more',
    );
  };

  useEffect(() => {
    loaderActions.loadComments(limit, 'comments-loading');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortOrder]);

  return (
    <>
      <ul
        id={`section-${sortOrder}`}
        className="srf-comments-comments"
        role="tabpanel">
        {['ready', 'comments-loading-more'].includes(appState) &&
          sortOrder === 'created' &&
          thread.state == 'closed' &&
          thread.goodbyeMessage !== '' && (
            <EditorialMessage message={thread.goodbyeMessage} />
          )}
        {['ready', 'comments-loading-more'].includes(appState) &&
          comments?.map((comment) => {
            return <Comment key={comment.id} comment={comment} />;
          })}
        {['ready', 'comments-loading-more'].includes(appState) &&
          sortOrder === 'created' &&
          !hasMoreComments &&
          thread.welcomeMessage !== '' && (
            <EditorialMessage message={thread.welcomeMessage} />
          )}
      </ul>
      <div className="srf-comments-footer">
        {['comments-loading', 'comments-loading-more'].includes(appState) && (
          <Spinner />
        )}
        {appState === 'comments-error' && <Error />}

        {hasMoreComments && appState === 'ready' && (
          <div className="srf-comments-show-more-bar-container">
            <ShowMoreBar
              // @ts-ignore
              styleModifier={'show-more-bar--with-borders'}
              showMoreText={'Mehr anzeigen'}
              onClick={handleShowMore}
              renderBackToTop={false}
            />
          </div>
        )}
      </div>
    </>
  );
};
